import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { PanelMenuService } from 'src/app/shared/common/services/panel-menu/panel-menu.service';

@Component({
    selector: 'custom-confirmation-popup',
    templateUrl: './custom-confirmation-popup.component.html'
})
export class CustomConfirmationPopupComponent implements OnInit, OnDestroy {
    @Input() title: string = 'MapViewer_Edit_ConfirmationMessage_Header';
    @Input() message: string = 'MapViewer_Edit_ConfirmationMessage';
    @Input() confirmButtonText: string = 'discard';
    @Input() isPermanentAction: boolean = false;
    @Input() id: string = '';
    @Input() confirmAction: () => Promise<void>;
    @Input() cancelAction: () => void;
    @Input() showPopup: boolean = false;

    private destroyed = new Subject<void>();

    constructor(private panelMenuService: PanelMenuService) {}

    ngOnInit(): void {
        this.panelMenuService.confirmationPopupDataStream.pipe(takeUntil(this.destroyed)).subscribe(data => {
            if (data) {
                this.title = data.title;
                this.message = data.message;
                this.confirmButtonText = data.confirmButtonText;
                this.isPermanentAction = data.isPermanentAction;
                this.id = data.id;
                this.confirmAction = data.confirmAction;
                this.showPopup = true;
            }
        });
    }

    ngOnDestroy(): void {
        this.panelMenuService.confirmationPopupDataStream.next(null);
        this.destroyed.next();
        this.destroyed.complete();
    }

    confirmActionHandler = (): Promise<void> => this.triggerConfirmAction();

    triggerConfirmAction(): Promise<void> {
        if (this.confirmAction) {
            return this.confirmAction().then(() => {
                this.showPopup = false;
            });
        } else {
            this.showPopup = false;
            return Promise.resolve();
        }
    }

    cancelActionHandler(): void {
        if (this.cancelAction) {
            this.cancelAction();
        } else {
            this.showPopup = false;
        }
    }
}
